import type { JSX } from 'react';

import KalshiLogo from 'components/DesignSystem/Icons/adhoc/KalshiLogo';
import { probabilityToOpacityAndColor } from 'components/ExternalWidgets/colors';
import ProbabilityBarCard from 'components/ExternalWidgets/components/probability-bar/probabilityBarCard';
import type { StateName } from 'components/ExternalWidgets/components/probability-bar/stateProjection';
import IconButton from 'DesignSystem2/Button/IconButton';
import ArrowCircleRightOutlinedIcon from 'DesignSystem2/Icon/material/ArrowCircleRightOutlined';
import Palette from 'DesignSystem2/Theme/Palette';
import type { MarketVo } from 'models';

interface ProbabilityWidgetProps {
    market: MarketVo | undefined;
    eventTicker: string;
    goToMarket: () => void;
}

const eventTickerMeta: { [key: string]: { title: string; subtitle: string } } = {
    'PRESPARTYNV-24': { title: 'Nevada', subtitle: '6 electoral votes' },
    'PRESPARTYGA-24': { title: 'Georgia', subtitle: '16 electoral votes' },
    'PRESPARTYAZ-24': { title: 'Arizona', subtitle: '11 electoral votes' },
    'PRESPARTYPA-24': { title: 'Pennsylvania', subtitle: '19 electoral votes' },
    'PRESPARTYWI-24': { title: 'Wisconsin', subtitle: '10 electoral votes' },
    'PRESPARTYMI-24': { title: 'Michigan', subtitle: '15 electoral votes' },
};

const ProbabilityWidget = ({ market, eventTicker, goToMarket }: ProbabilityWidgetProps): JSX.Element => {
    if (!market || !eventTickerMeta[eventTicker]) {
        return <></>;
    }

    const { title, subtitle } = eventTickerMeta[eventTicker];

    return (
        <div className="p-2 w-[488px] box-content rounded-x30 border border-fill-x40 border-solid relative">
            <div className="absolute top-2 right-2 flex gap-1 items-center align-middle">
                <KalshiLogo color={Palette.Brand.Primary} height="12px" />
                <IconButton
                    color={Palette.Fill.x30}
                    icon={ArrowCircleRightOutlinedIcon}
                    rank="tertiary"
                    size="small"
                    style={{ border: 'none', backgroundColor: 'transparent', cursor: 'pointer' }}
                    onClick={goToMarket}
                />
            </div>
            <ProbabilityBarCard
                leftVariant="red"
                rightVariant="blue"
                leftProbability={100 - market.last_price}
                withPartyLabels
                title={title}
                subtitle={subtitle}
                href={`/events/${eventTicker}`}
                state={{
                    state: title.toLowerCase() as StateName,
                    ...probabilityToOpacityAndColor(100 - market.last_price),
                }}
                eventTicker={eventTicker}
                marketTicker={market.ticker_name}
                isPresidency={true}
                imageSize={32}
                withMargin={false}
                stackTitle={true}
            />
        </div>
    );
};

export default ProbabilityWidget;
